export const AI_CREDIT_LIMIT_MESSAGE = 'Credit limit exceeded';

export class AiCreditLimitError extends Error {
  readonly statusCode: 402 | 403;

  constructor(message: string = AI_CREDIT_LIMIT_MESSAGE, statusCode: 402 | 403 = 403) {
    super(message);
    this.name = 'AiCreditLimitError';
    this.statusCode = statusCode;
  }
}

export function isAiCreditLimitError(error: unknown): boolean {
  if (error instanceof AiCreditLimitError) {
    return error.message === AI_CREDIT_LIMIT_MESSAGE && (error.statusCode === 402 || error.statusCode === 403);
  }

  if (typeof error === 'object' && error !== null) {
    const record = error as { message?: unknown; statusCode?: unknown };
    return record.message === AI_CREDIT_LIMIT_MESSAGE && (record.statusCode === 402 || record.statusCode === 403);
  }

  return false;
}
